/**
 * 本文件是消息弹窗函数模块
 * @author 笑三少
 */
import ElementPlus from 'element-plus'
import { markRaw } from 'vue'
import 'element-plus/dist/index.css'
import {ElMessageBox} from 'element-plus'
import { QuestionFilled } from '@element-plus/icons-vue'
import type { Action } from 'element-plus'

const PROJECT_NAME = import.meta.env.VITE_APP_NAME
class MessageBox {
  private title: string
  private okButtonText: string
  private cancelButtonText: string
  constructor() {
    this.title = PROJECT_NAME || '提示信息'
    this.okButtonText='确定'
    this.cancelButtonText='取消'
  }

  /**
   * 提示消息弹窗
   * @param message 提示内容
   * @returns Promise<Action | null>
   */
  async messageBox(message: string): Promise<Action> {
    try{
      return await ElMessageBox.alert(message, this.title, {
        confirmButtonText: this.okButtonText,
        type: 'info',
        draggable: true,
        closeOnClickModal: false
      })
    }catch (error) {
      // 用户取消，返回 null 或特定值
      if (error === 'cancel' || error?.action === 'cancel') return null;
      // 其他错误重新抛出
      throw error;
    }
  }

  /**
   * 确认弹窗
   * @param message 确认内容
   * @returns Promise<Action | null>
   */
  async confirmBox(message: string): Promise<Action> {
    try{
      return await ElMessageBox.confirm(message, this.title, {
        confirmButtonText: this.okButtonText,
        cancelButtonText: this.cancelButtonText,
        type: 'warning',
        icon: markRaw(QuestionFilled),
        draggable: true,
        closeOnClickModal: false
      })
    }catch (error) {
      // 用户取消，返回 null 或特定值
      if (error === 'cancel' || error?.action === 'cancel') return null;
      // 其他错误重新抛出
      throw error;
    }
  }

  /**
   * 错误消息弹窗
   * @param message 错误内容
   * @returns Promise<Action | null>
   */
  async errorBox(message: string): Promise<Action> {
    try{
      return await ElMessageBox.alert(message, this.title, {
        confirmButtonText: this.okButtonText,
        type: 'error',
        draggable: true,
        closeOnClickModal: false
      })
    }catch (error) {
      // 用户取消，返回 null 或特定值
      if (error === 'cancel' || error?.action === 'cancel') return null;
      // 其他错误重新抛出
      throw error;
    }
  }
}
const messageBox = new MessageBox()
export const showMessage = messageBox.messageBox.bind(messageBox)
export const showConfirm = messageBox.confirmBox.bind(messageBox)
export const showError = messageBox.errorBox.bind(messageBox)
export default messageBox

